export function pmt(
  principal: number,
  annualRate: number,
  months: number,
): number {
  if (principal <= 0) return 0;
  const r = annualRate / 12;
  if (r === 0) return principal / months;
  return (
    (principal * (r * Math.pow(1 + r, months))) /
    (Math.pow(1 + r, months) - 1)
  );
}

export function maxLoanFromMonthly(
  monthly: number,
  annualRate: number,
  months: number,
): number {
  if (monthly <= 0) return 0;
  const r = annualRate / 12;
  if (r === 0) return monthly * months;
  return (
    (monthly * (Math.pow(1 + r, months) - 1)) /
    (r * Math.pow(1 + r, months))
  );
}
